import { useMessages } from '@features/l10n/l10nInjector.js';
import { LongPressTooltip } from '@shared/components/LongPressTooltip.js';
import { useOnline } from '@shared/hooks/useOnline.js';
import type { ReactElement, ReactNode } from 'react';
import { BiWifiOff } from 'react-icons/bi';

type Props = {
  className?: string;
  /** Replaces the generic "needs a connection" wording. */
  hint?: ReactNode;
};

/**
 * Says that a control needs a connection, with the reason in a tooltip; renders
 * nothing while online. As in `PremiumGem`, `pointerEvents: 'initial'` keeps it
 * hoverable inside a disabled dropdown item, which takes pointer events away
 * from its content.
 */
export function OfflineBadge({ className, hint }: Props): ReactElement | null {
  const m = useMessages();

  const online = useOnline();

  if (online) {
    return null;
  }

  return (
    <LongPressTooltip label={hint ?? m?.general.offlineUnavailable}>
      {({ props }) => (
        <span
          {...props}
          className={className}
          style={{ pointerEvents: 'initial', cursor: 'help' }}
        >
          <BiWifiOff />
        </span>
      )}
    </LongPressTooltip>
  );
}
